import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { countryUrls } from "../URL/ApplicationUrls";
import { Country } from "./Country";
import { minutesAsMilliSeconds } from "../Utils/time";
import { sortArrayBy } from "../Utils/arrays";

export const useFetchCountries = () => {
  return useQuery<Country[], Error>({
    queryKey: "countries",
    staleTime: minutesAsMilliSeconds(120),
    cacheTime: minutesAsMilliSeconds(240),
    queryFn: () => fetchCountries(),
    onError: () => toast.error("An error occurred when retrieving the countries"),
  });
};

const fetchCountries = async () => {
  const { data: countries } = await axios.get<Country[]>(countryUrls.base.apiUrl);

  sortArrayBy({ values: countries, keyToSort: "Name" });

  return countries;
};
